import React, { useContext, useEffect, useState } from 'react';
import { Chip, Grid, Tooltip } from '@nextiva/next-ui-components';
import { PropTypes } from 'prop-types';

import { UserTeam } from 'components/SvgIcon';
import { ChipsShadow } from 'components/ShadowBox';
import Hint from 'components/Hint';

import { UserDrawerContext } from '../../../UserDrawerContent/UserDrawerContext';
import { UserContext } from '../../../usersContext';

import { TeamChips } from './TeamChips';
import { AddTeam } from './AddTeam';
import classes from './TeamsSections.scss';

export const TeamsSection = ({ primaryTeam, showPrimaryTeam }) => {
  const [primaryTeamName, setPrimaryTeamName] = useState('');
  const {
    dispatchUserDrawer,
    userDrawerState: { assignedTeams = [], isTeamsLoading },
  } = useContext(UserDrawerContext);

  const {
    userState: { teamsOptions },
  } = useContext(UserContext);

  useEffect(() => {
    if (teamsOptions.find((team) => team.key === primaryTeam)) {
      setPrimaryTeamName(
        teamsOptions.find((team) => team.key === primaryTeam).label,
      );
    }
  }, [primaryTeam]);

  const ShowPrimaryTeam = () => {
    if (isTeamsLoading) {
      return <ChipsShadow length={1} />;
    }

    return (
      <Tooltip
        title={
          <div className="Body m-chip-group__chips__tooltip">
            {primaryTeamName}
          </div>
        }
        placement="top"
      >
        <Chip
          className={classes.chip}
          icon={
            <span
              className="m-user-edit-drawer-section__chips__icon"
              data-testid="PlatformAdminUI-UsersLink-TeamsSection-PrimaryTeamChipsIcon"
            >
              <UserTeam />
            </span>
          }
          label={
            <div className="m-chip-group__chips__label">
              <div className="Label">
                <div
                  className="Body-Emphasis m-chip-group__chips__label__text"
                  data-testid="PlatformAdminUI-UsersLink-TeamsSection-PrimaryTeamChipsLabelText"
                >
                  {primaryTeamName}
                </div>
              </div>
            </div>
          }
        />
      </Tooltip>
    );
  };

  return (
    <Grid container>
      <div className="m-user-edit-drawer-section__team-descriptions-text">
        Teams can be used to route calls and other communication channels as
        well as other smart defaults throughout the platform.
      </div>
      {showPrimaryTeam && (
        <Grid item xs={12}>
          <div
            className="Hint-Emphasis m-user-edit-drawer-section__team-text"
            data-testid="PlatformAdminUI-UsersLink-TeamsSection-PrimaryTeamText"
          >
            <Hint
              tool="Primary Team"
              tip="Need to update Primary Team? Update dropdown above."
            />
          </div>
          <div>
            <ShowPrimaryTeam />
          </div>
        </Grid>
      )}
      <div className="m-user-edit-drawer-section">
        <Grid item xs={12}>
          <div
            className="Hint-Emphasis m-user-edit-drawer-section__text"
            data-testid="PlatformAdminUI-UsersLink-TeamsSection-AssignedTeamsToUser"
          >
            Teams currently assigned to this user
          </div>
        </Grid>
        <Grid item xs={12}>
          <TeamChips
            primaryTeam={primaryTeam}
            showPrimaryTeam={showPrimaryTeam}
          />
          <AddTeam
            dispatchUserDrawer={dispatchUserDrawer}
            teams={teamsOptions}
            primaryTeam={primaryTeam}
            assignedTeams={assignedTeams}
          />
        </Grid>
      </div>
    </Grid>
  );
};

TeamsSection.propTypes = {
  primaryTeam: PropTypes.number.isRequired,
  showPrimaryTeam: PropTypes.bool.isRequired,
};
